
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import VueRouter, { RawLocation } from "vue-router";
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";
import { fetchLineRegister } from "@/services/userService";
import BoxError from "@/components/box/BoxError/BoxError.vue";
import store from "@/store";
const Words: Dictionary = {
  error: "所属先IDまたは所属先パスワードに誤りがあります。",
  account: "所属先ID",
  password: "所属先パスワード",
  login: "次へ",
};
const systemErrorObj = {
  title: "システムエラー",
  message: "サーバーからの応答が無いため処理を実行できませんでした。<br />お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。",
  button: "top"
}

@Component({
  components: {
    LoadingAnimation,
    BoxError,
  },
})
export default class FormAlignmentLineLoggedIn extends Vue {
  private words = Words;
  // private username = null;
  // private password = null;
  private agree: boolean = false;
  private error: string | null = null;
  // private meta = this.$route.meta;
  private loading: boolean = false;
  private showLoading: boolean = false;
  private loadingTimerId: number | null = null;

  private boxError: {title: string; message: string; button: string | null;} | null = null;

  @Prop({ type: String, default: "" })
  readonly lineAccessToken!: string;
  // private redirectPayload: { access_token: string; id_token: string } | null =
  //   null;

  get lang(): string {
    return store.getters["auth/lang"];
  }

  get token(): string {
    return store.getters["auth/token"];
  }

  @Watch("loading")
  private onChagedLoading(newState: boolean) {
    if (this.loadingTimerId) {
      clearTimeout(this.loadingTimerId);
      this.loadingTimerId = null;
    }
    if (newState) {
      this.loadingTimerId = window.setTimeout(() => {
        this.showLoading = true;
        this.loadingTimerId = null;
      }, 3000);
    } else {
      this.showLoading = false;
    }
  }


  private handleSkip() {
    this.$emit("skipLeaveConfirm");
    void this.$router.push(this.getNormalizedReturnLocation()).catch((err) => {
      if (VueRouter.isNavigationFailure(err)) {
        return;
      }
      throw err;
    });
  }

  private getNormalizedReturnLocation(): RawLocation {
    let redirect = this.$route.query.redirect;
    if (redirect && typeof redirect !== "string") {
      redirect = redirect[0] || "/";
    }
    if (redirect) {
      return this.$router.resolve(redirect as string).location;
    }

    let from = this.$route.query.from;
    if (from && typeof from !== "string") {
      from = from[0] || "/";
    }
    const raw = (from as string) || "/";
    return this.$router.resolve(raw).location;
  }

  @Emit()
  private async onSubmit() {
    this.error = null;

    if (!this.agree) {
      console.warn("利用規約への同意をお願いします");
      this.error = "利用規約への同意をお願いします";
      return;
    }

    if (!this.lineAccessToken) {
      this.$emit("redirectToLineAuth");
      return;
    }

    try {
      this.loading = true;

      await fetchLineRegister(this.lineAccessToken)
        .then(async (data)=>{
          await store.dispatch("auth/updateUser")
          this.$emit("updateViewState", 2.5);
        })
        .catch((e)=>{
          if (e.status === 406) {
            this.boxError = {
              title: "LINEアカウントでのログインが出来ません",
              message: `ご指定の所属先IDでは、LINE機能を介した<br class='pc'>ログインをご利用いただけません。<br><br><a href="/">ログイン画面</a>に戻り、「所属先ID・パスワードでログイン」からお進みください。`,
              button: "top"
            }
          } else {
            this.boxError = systemErrorObj;
          }
        })

    } catch (e: any) {
      console.error("catch", e);
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }

  // created() {
  //   if (store.state.temp.redirectPayload) {
  //     this.redirectPayload = store.state.temp.redirectPayload;
  //   } else {
  //     this.$router.push({
  //       name: "error",
  //       query: {
  //         status: "500",
  //       },
  //     });
  //   }
  // }
  
}
